import $ from 'jquery';
import 'slick-carousel';

export default function slider() {

  function sliderHero() {
    $('.slider-hero').slick({
      arrows: true,
      dots: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      slidesToShow: 1
    });
  }

  function sliderProgetti() {
    $('.slider-progetti').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 2,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    });
  }

  function sliderBisogni() {
    $('.slider-bisogni').each(function () {
      var $carouselBisogni = $(this);
      if ($(window).width() >= 991) {
        if ($carouselBisogni.hasClass('slick-initialized')) {
          $carouselBisogni.slick('unslick');
        }
      }
      else {
        if (!$carouselBisogni.hasClass('slick-initialized')) {
          $carouselBisogni.slick({
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
          });
        }
      }
    });
  }

  function sliderNews() {
    $('.slider-news').slick({
      arrows: true,
      dots: true,
      infinite: false,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  function sliderHelp() {
    $('.slider-help').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    });
  }

  function sliderNewsRelated() {
    $('.slider-news-related').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 2,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    });
  }

  function sliderContiRelated() {
    $('.slider-conti-related').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    });
  }

  function sliderCarteRelated() {
    $('.slider-carte-related').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    });
  }

  function sliderFinanziamentiRelated() {
    $('.slider-finanziamenti-related').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    });
  }

  function sliderMarketingRelated() {
    $('.slider-marketing-related').slick({
      arrows: false,
      dots: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    });
  }

  $( document ).ready(function() {

    if($('.slider-hero').length > 0) {
      sliderHero();
    }

    if($('.slider-progetti').length > 0) {
      sliderProgetti();
    }

    if($('.slider-bisogni').length > 0) {
      $(window).on('load resize orientationchange', function() {
        sliderBisogni();
      });
    }

    if($('.slider-news').length > 0) {
      sliderNews();
    }

    if($('.slider-help').length > 0) {
      sliderHelp();
    }

    if($('.slider-news-related').length > 0) {
      sliderNewsRelated();
    }

    if($('.slider-conti-related').length > 0) {
      sliderContiRelated();
    }

    if($('.slider-carte-related').length > 0) {
      sliderCarteRelated();
    }

    if($('.slider-finanziamenti-related').length > 0) {
      sliderFinanziamentiRelated();
    }

    if($('.slider-marketing-related').length > 0) {
      sliderMarketingRelated();
    }
    
  });
}